function sanitizeJSONString(text) { // Some characters to escape
  let sanitizedString = text.replace(/\\/g, "\\\\"); // Backslash
  sanitizedString = sanitizedString.replace(/\n/g, "\\n"); // Line break
  sanitizedString = sanitizedString.replace(/\t/g, "\\t"); // Tabulator
  sanitizedString = sanitizedString.replace(/"/g, "\\\""); // Double quote
  sanitizedString = sanitizedString.replace(/@\[([^\]]+)\]\(urn:li:(organization|person):([^)])+\)/g, ""); // Linkedin mention
  return sanitizedString;
}

export default sanitizeJSONString;
